import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Row,
  Col,
} from "reactstrap";

import axios from "axios";

import React, { Component } from "react";
import { cambioPass } from "../components/utils/Contratos.js";

import { Alert } from "reactstrap";

class CambioPass extends Component {
  constructor(props) {
    super(props);
    this.state = {
      usuario: "",
      password1: "",
      password2: "",
      buttonDesactivo: false,
      mostrarAlerta: false,
      mensajeAlert: "",
      color: "danger",
      tokenCambio:
        this.props.match.params.id === ":id" ? "" : this.props.match.params.id,
    };
  }

  cambio = async () => {
    cambioPass.password = this.state.password1;
    cambioPass.token = this.state.tokenCambio;

    const request = await axios.post(
      global.config.urlBase + "/usuario/cambiopass",
      cambioPass
    );

    if (request.status === 200) {
      if (request.data.mensaje.estatus) {
        this.setState(
          {
            mostrarAlerta: true,
            mensajeAlert: request.data.mensaje.mensaje,
            color: "success",
          },
          () => {
            let _exQualityInterval = setTimeout(() => {
              this.setState({ mostrarAlerta: false });
              clearInterval(_exQualityInterval);
              window.location.href = "/auth/login";
            }, 3000);
          }
        );
      } else {
        this.setState(
          {
            mostrarAlerta: true,
            mensajeAlert: request.data.mensaje.mensaje,
            color: "danger",
          },
          () => {
            let _exQualityInterval = setTimeout(() => {
              this.setState({ mostrarAlerta: false });
              clearInterval(_exQualityInterval);
            }, 3000);
          }
        );
      }
    }
  };

  handleChange = (e) => {
    var valorPass1 = "";
    var valorPass2 = "";
    if (e.target.name === "password1") {
      valorPass1 = e.target.value;

      this.setState({ password1: valorPass1 });
    } else if (e.target.name === "password2") {
      valorPass2 = e.target.value;
      this.setState({ password2: valorPass2 });
    }

    /*
    if((this.state.password1 && this.state.password2)!= '' && (this.state.password1 === this.state.password2)){


      this.setState({buttonDesactivo:false});

    }else{
      this.setState({buttonDesactivo:true});

    }
    */
    this.validarEnvio();
  };

  validarEnvio = () => {
    if (this.state.password1 !== "" && this.state.password2 !== "") {
      if (this.state.password1 === this.state.password2) {
        return false;
      } else {
        return true;
      }
    } else {
      return true;
    }
  };

  componentDidMount = async () => {};

  render() {
    return (
      <>
        <Col lg="5" md="7">
          {this.state.mostrarAlerta ? (
            <Alert color={this.state.color}>
              <strong></strong> {this.state.mensajeAlert}!
            </Alert>
          ) : null}
          <Card className="bg-secondary shadow border-0">
            <CardHeader className="bg-transparent pb-5">
              <div className="text-muted text-center mt-2 mb-3">
                <small>Ingresa los datos necesarios</small>
              </div>
            </CardHeader>
            <CardBody className="px-lg-5 py-lg-5">
              <Form role="form">
                <FormGroup className="mb-3">
                  <InputGroup className="input-group-alternative">
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="ni ni-lock-circle-open" />
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input
                      value={this.state.password1}
                      onChange={this.handleChange}
                      name="password1"
                      placeholder="Password"
                      type="password"
                      autoComplete="new-email"
                    />
                  </InputGroup>
                </FormGroup>

                <FormGroup className="mb-3">
                  <InputGroup className="input-group-alternative">
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="ni ni-lock-circle-open" />
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input
                      value={this.state.password2}
                      onChange={this.handleChange}
                      name="password2"
                      placeholder="Password"
                      type="password"
                      autoComplete="new-email"
                    />
                  </InputGroup>
                </FormGroup>
                <div className="text-center">
                  <Button
                    className="my-4"
                    color="primary"
                    type="button"
                    disabled={this.validarEnvio()}
                    onClick={() => this.cambio()}
                  >
                    Cambiar Password
                  </Button>
                </div>
              </Form>
            </CardBody>
          </Card>
          <Row className="mt-3"></Row>
        </Col>
      </>
    );
  }
}

export default CambioPass;
